import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsAccountHistoryParser } from "@/models/admin/warrantsAccountHistory/warrantsAccountHistory.parser"
import { IWarrantsAccountHistory } from "@/models/admin/warrantsAccountHistory/warrantsAccountHistory.types"
import {
  Financials_Warrants_Accounts_History_Bool_Exp,
  Financials_Warrants_Accounts_History_Order_By,
  GetWarrantsAccountsHistoryQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsAccountHistoryListResult {
  history: IWarrantsAccountHistory[]
  totalCount: number
}

class WarrantsAccountHistoryServiceClass {
  getHistory(
    accountNumber: string,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Accounts_History_Order_By,
  ): QueryResult<WarrantsAccountHistoryListResult> {
    const where: Financials_Warrants_Accounts_History_Bool_Exp = {
      account_number: { _eq: accountNumber },
    }

    return useQuery({
      ...HasuraQueries.warrants.accountsHistory(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { history: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsAccountsHistoryQuery,
      ): WarrantsAccountHistoryListResult => ({
        history: data.financials_warrants_accounts_history.map(
          WarrantsAccountHistoryParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_accounts_history_aggregate.aggregate
            ?.count ?? 0,
      }),
    })
  }
}

export const WarrantsAccountHistoryService =
  new WarrantsAccountHistoryServiceClass()
